import { getItemFromCollection } from "directus/src/operations";

export async function fetchTestimonialData({ testimonialId }) {
  try {
    const response = await getItemFromCollection("testimonials", testimonialId, {
      fields: ["id", "feedback", "video.id", "video.type", "review_url", "client"],
    });
    // Keep `video` as the file id so dirty checks and update payloads stay unchanged;
    // the MIME type is exposed separately for the preview.
    return {
      ...response,
      video: response?.video?.id ?? null,
      video_type: response?.video?.type ?? null,
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
}
